import { dialogPageTypes } from "../../../const/dialogPageTypes";
import { openDialogUser, setPageType } from "../../../redux/reducers/dialogUser-reducer";

export const handleDialogToEditUser = ({ dialogType, rowInfo },  dispatch, event = null) => {
  if(event) event.stopPropagation();  
  dispatch(setPageType(dialogPageTypes.user));
  dispatch(openDialogUser({ dialogType, rowInfo }));
};